class Party {
  id: string;
  name: string;
  organization: string;
  logo: string;

  constructor(client: any) {
    this.id = client.id;
    this.name = client.name;
    this.organization = client.organization;
    this.logo = client.logo;
  }
}

export class Contract {
  id: string;
  promisor: Party;
  promisee: Party;

  constructor(id: string, promisor: any, promisee: any) {
    this.id = id;
    this.promisor = new Party(promisor);
    this.promisee = new Party(promisee);
  }
}
